var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "plus@svg")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page---new-updates-Oct-2021",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-XS-Mobile-web-(Expanded-menu)",
    transform: "translate(-20.000000, -603.000000)",
    fill: "#212529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "translate(0.000000, 260.299962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "About,-business,-legal",
    transform: "translate(16.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(0.000000, 338.877520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,4 C12.5522847,4 13,4.44771525 13,5 L13,11 L19,11 C19.5522847,11 20,11.4477153 20,12 C20,12.5522847 19.5522847,13 19,13 L12.999,13 L13,19 C13,19.5522847 12.5522847,20 12,20 C11.4477153,20 11,19.5522847 11,19 L10.999,13 L5,13 C4.44771525,13 4,12.5522847 4,12 C4,11.4477153 4.44771525,11 5,11 L11,11 L11,5 C11,4.44771525 11.4477153,4 12,4 Z"
  }))))))));
};
export default SvgPlus;